<div class="period-value-cell"
     [portalDraggable]="payload"
     [isDraggable]="!hasRealHours && !isReadOnly && plannedHours !== undefined"
     [draggingClassList]="['portal-bold', 'portal-flex-center', 'portal-box', 'portal-box-border', 'card-container']"
     [class.readonly]="hasRealHours || isReadOnly"
     [class.separated-cell]="!isFirstColumn"
     [class.edited]="isBeingEdited"
     matTooltip="{{'resource-management.planningBoard.tooltips.readonlyCellOnPastPeriods' | translate}}"
     [matTooltipDisabled]="!hasRealHours">

  @if(hasRealHours) {
  <p class="real-hours">{{(realHours ?? 0) | formatNumber }}</p>
  } @else if (!isReadOnly && (useDraggingAnchor$ | async)) {
  <div #draggingAnchor
       class="drag-icon portal-icon-button btn-small portal-none">
    <fa-icon class="btn-icon"
             [icon]="['fas', 'grip-dots-vertical']" />
  </div>
  }
  <p class="planned-hours"
     [class.inactive]="!hasRealHours && plannedHours && !isProjectActive">

    {{plannedHours | formatNumber:'-'}}
  </p>

  <div class="portal-none overflow portal-show-when-focus"
       (click)="openContextMenu($event)">...</div>
</div>

<al-cell-drop-zone [node]="node"
                   [period]="(hasRealHours || isReadOnly) ? undefined : period" />

@if(note) {
<div class="note-touch"
     [matTooltip]="note"
     [class.portal-clickable]="canBeSideEdited"
     matTooltipClass="mat-tooltip-multiline"
     matTooltipPosition="right"
     (click)="$event.stopPropagation(); openNoteBoard();">
  <span class="note-marker"></span>
</div>
}